module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAABWAgMAAAAoOIlkAAAADFBMVEUAAACenp62traZmZkC3IDOAAAAA3RSTlMAKgcLeZ1VAAAAMUlEQVQ4y2MYKYD/PwRcqIcyRoVHhYeiMGsoBCRMhTLIyAyYhgw2X44KjwqTJzxSAAA0KsDOfwSqtwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/Windows.png
// module id = U2UW
// module chunks = 1